"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailedItemRow = exports.DetailedColumn = exports.DetailedContainer = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var DetailedContainer = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(core_1.Grid, __assign({ container: true, spacing: 6 }, rest), children));
};
exports.DetailedContainer = DetailedContainer;
var DetailedColumn = function (_a) {
    var children = _a.children, containerProps = _a.containerProps, rest = __rest(_a, ["children", "containerProps"]);
    return (react_1.default.createElement(core_1.Grid, __assign({ item: true, xs: 6 }, rest),
        react_1.default.createElement(core_1.Grid, __assign({ container: true, spacing: 3 }, containerProps), children)));
};
exports.DetailedColumn = DetailedColumn;
var DetailedItemRow = function (_a) {
    var children = _a.children, containerProps = _a.containerProps, rest = __rest(_a, ["children", "containerProps"]);
    return (react_1.default.createElement(core_1.Grid, __assign({ item: true, xs: 12 }, rest),
        react_1.default.createElement(core_1.Grid, __assign({ container: true, spacing: 2, style: { position: 'relative' } }, containerProps), children)));
};
exports.DetailedItemRow = DetailedItemRow;
//# sourceMappingURL=Grid.js.map